import { FC } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface ResetFormInputs {
  password: string;
  confirmPassword: string;
}

const schema = yup.object().shape({
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Minimum 8 characters')
    .matches(/[A-Z]/, 'One uppercase letter required')
    .matches(/\d/, 'One number required')
    .matches(/[@$!%*?&]/, 'One special character required'),
  confirmPassword: yup
    .string()
    .required('Confirm Password is required')
    .oneOf([yup.ref('password')], 'Passwords must match')
});

const ResetPassword: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetFormInputs>({
    resolver: yupResolver(schema),
  });

  const onSubmit: SubmitHandler<ResetFormInputs> = (data) => {
    console.log('New Password:', data.password);
    // Call reset password API
  };

  return (
    <div className="auth-container">
      <h2>wizkind</h2>
      <p className="font-semibold">Type in your new password</p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          type="password"
          placeholder="New Password"
          {...register('password')}
          className="input"
        />
        {errors.password && <p className="error-text">{errors.password.message}</p>}

        <input
          type="password"
          placeholder="Confirm Password"
          {...register('confirmPassword')}
          className="input"
        />
        {errors.confirmPassword && <p className="error-text">{errors.confirmPassword.message}</p>}

        <button type="submit" className="btn-primary">Continue</button>
      </form>
    </div>
  );
};

export default ResetPassword;
